import { call, put, takeEvery, all, fork } from "redux-saga/effects";

// Crypto Redux States
import { COUNTS, GET_BAR_CHART, GET_CHARTS_DATA, GET_PIE_CHART, GET_RECENT_QUOTES } from "./actionTypes";
import { apiSuccess, apiFail, getCountsSuccess, getCountsFail, getRecentQuotesSuccess, getRecentQuotesFail, getPieChartDataSuccess, getPieChartDataFail, getBarChartDataSuccess, getBarChartDataFail } from "./actions";

//Include Both Helper File with needed methods
import {
    getWeeklyData,
    getYearlyData,
    getMonthlyData,
    getCounts,
    getRecentQuotes,
    getPieChart,
    getBarChart,
}
    from "../../helpers/backend_helper";
import toast from "react-hot-toast";


function* getChartsData({ payload: periodType }) {
    try {
        var response;
        if (periodType == "monthly") {
            response = yield call(getWeeklyData, periodType);
        }
        if (periodType == "yearly") {
            response = yield call(getYearlyData, periodType);
        }
        if (periodType == "weekly") {
            response = yield call(getMonthlyData, periodType);
        }

        yield put(apiSuccess(GET_CHARTS_DATA, response)); 
    } catch (error) {
        yield put(apiFail(GET_CHARTS_DATA, error));
    }
}

export function* watchGetChartsData() {
    yield takeEvery(GET_CHARTS_DATA, getChartsData);
}

function* dashboardSaga() {
    yield all([fork(watchGetChartsData)]);
}

export default dashboardSaga;

//Get Users count
function* fetchCounts() {
    try {
        const response = yield call(getCounts)
        yield put(getCountsSuccess(response))
    } catch (error) {
        yield put(getCountsFail(error))
    }
}
export function* CountsSaga() {
    yield takeEvery(COUNTS, fetchCounts)
}

//Get recent quotes
function* fetchRecentQuotes() {
    try {
        const response = yield call(getRecentQuotes)
        yield put(getRecentQuotesSuccess(response))
    } catch (error) {
        yield put(getRecentQuotesFail(error))
    }
}
export function* RecentQuotesSaga() {
    yield takeEvery(GET_RECENT_QUOTES, fetchRecentQuotes)
}

//Get pie chart
function* fetchPieChart() {
    try {
        const response = yield call(getPieChart)
        yield put(getPieChartDataSuccess(response))
    } catch (error) {
        yield put(getPieChartDataFail(error))
    }
}
export function* PieChartSaga() {
    yield takeEvery(GET_PIE_CHART, fetchPieChart)
}

//Get bar chart
function* fetchBarChart() {
    try {
        const response = yield call(getBarChart)
        yield put(getBarChartDataSuccess(response))
    } catch (error) {
        yield put(getBarChartDataFail(error))
    }
}
export function* BarChartSaga() {
    yield takeEvery(GET_BAR_CHART, fetchBarChart)
}